import extractSecretKey from '../data_management/extractSecretKey'

class BrandingInteractor {
  constructor(initialDataInteractor, coachGateway) {
    this.initialDataInteractor = initialDataInteractor;
    this.coachGateway = coachGateway;
  }

  loadDefaultBranding() {
    return new Promise(resolve => {
      this.initialDataInteractor.ensureInitializedSession().then(() => {
        this.coachGateway.getDefaultBranding(extractSecretKey(this.initialDataInteractor))
          .then((response) => {
            this.defaultBranding = response.branding;
            resolve(response);
          });
      });
    });

  }

  updateBranding(branding) {
    return this.coachGateway.updateBranding(extractSecretKey(this.initialDataInteractor), branding)
      .then(data => {
        this.defaultBranding = data;
        return data;
      })
  }

  getCurrentLogoUrl() {
    return this.coachGateway.getCurrentLogoUrl(extractSecretKey(this.initialDataInteractor)).then(data => data.url);
  }

  getCurrentStoreImageUrl() {
    return this.coachGateway.getCurrentStoreImageUrl(extractSecretKey(this.initialDataInteractor)).then(data => data.url);
  }
}

export default BrandingInteractor